import { useQuery } from '@tanstack/react-query';
import { ClinicLocationService } from '../services/clinic-location.service';

/**
 * Fetches a single patient by id within a clinic location (doctor/provider view).
 *
 * Invalidate the `['clinic-location-patient', clinicLocationId, patientId]` key
 * after mutations (assign/revoke, fullscript link/unlink) to refetch.
 */
export function useClinicLocationPatient(
  clinicLocationId: string | undefined,
  patientId: string | undefined
) {
  return useQuery({
    queryKey: ['clinic-location-patient', clinicLocationId, patientId],
    queryFn: () =>
      ClinicLocationService.getPatientById(clinicLocationId, patientId!),
    enabled: !!clinicLocationId && !!patientId,
  });
}
